import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"

const IndexPage = ({ data }) => {
  const imgData = data.fileName.childImageSharp.fluid
  const author = "v"
  const quote = `You are part of my story, memory and scenery, thank you.`

  return <Layout imgData={imgData} author={author} quote={quote} />
}

export default IndexPage

export const query = graphql`
  query {
    fileName: file(relativePath: { eq: "v3.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
